"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
var types_1 = require("./types");
var themes_1 = require("../../themes");
exports.useStyles = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        root: {
            display: 'flex',
            alignItems: 'center',
            // paddingTop: theme.spacing(1),
            // paddingBottom: theme.spacing(1),
        },
        header: {
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        titleSection: {
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
        },
        headerInfo: {
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            '& .MuiButton-root': {
                minWidth: 'none !important',
            },
        },
        title: {
            fontWeight: 800,
            fontSize: '16px',
            paddingRight: '20px',
        },
        flag: {},
        chip: function (_a) {
            var chipType = _a.chipType;
            var backgroundColor;
            var color;
            switch (chipType) {
                case types_1.ChipType.error:
                    backgroundColor = '#942b33';
                    color = 'white';
                    break;
                case types_1.ChipType.warn:
                    backgroundColor = '#e4c254';
                    color = 'black';
                    break;
                case types_1.ChipType.ok:
                    backgroundColor = '#3f9876';
                    color = 'white';
                    break;
                case types_1.ChipType.default:
                    backgroundColor = '#e2e3e5';
                    color = "".concat(themes_1.materialColors.blue[900]);
                    break;
                default:
                    break;
            }
            return {
                marginLeft: '12px',
                backgroundColor: backgroundColor,
                color: color,
                textTransform: 'uppercase',
                fontSize: '10px',
                fontWeight: 'bold',
            };
        },
        popOverButton: {
            padding: '0px 0px 0px 8px',
            minWidth: '0px',
            height: '42px',
        },
    });
});
